import { render, staticRenderFns } from "./TheSourcePagination2Page.vue?vue&type=template&id=2c831bfb&scoped=true&"
import script from "./TheSourcePagination2Page.vue?vue&type=script&lang=js&"
export * from "./TheSourcePagination2Page.vue?vue&type=script&lang=js&"
import style0 from "./TheSourcePagination2Page.vue?vue&type=style&index=0&id=2c831bfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c831bfb",
  null
  
)

export default component.exports